import { BaseQuery, DocumentType, NotesInputUpdate } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToNotesInputUpdate = (q: BaseQuery, assignee?: string): NotesInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    component: q.queryDetails?.__typename === 'NotesQuery' ? q.queryDetails?.component : '',
    documentType:
      q.queryDetails?.__typename === 'NotesQuery'
        ? q.queryDetails?.documentType
        : DocumentType.SAP_NOTE,
    documentNumber:
      q.queryDetails?.__typename === 'NotesQuery' ? q.queryDetails?.documentNumber : ''
  };
};
